/**
 * FreeFic 品牌 - Home 页面配置
 */
import { homeCommonConfig } from './common'
import type { HomePageConfig } from './types'

/**
 * FreeFic 品牌主题配置
 */
export const theme = {
  // 首页背景图
  homeBg: '/images/freefic/home-bg.svg',
  // 标签模块背景图
  tagsBg: '/images/freefic/tag-background.svg',

  // 标签按钮选中状态 (使用品牌主色)
  tagActiveBg: '#E65F3D',
  tagActiveText: '#FFFFFF',

  // 标签按钮未选中状态
  tagInactiveBg: '#FFF7EF',
  tagInactiveText: '#E65F3D',

  // Tab 激活状态渐变底部装饰线
  tabActiveGradient: 'linear-gradient(270deg, #F6F7F9 0%, #E65F3D 95%)',
  // Tab 激活状态文字和下划线颜色
  tabActiveColor: '#E65F3D',
  // sticky-header 背景渐变
  stickyHeaderBg: 'linear-gradient(180deg, #FFF7EF 0%, #FFFFFF 100%)',
  // 顶部 Banner 撑满屏宽，无底部圆角
  topBannerRadius: '0',
} as const

export const homeConfig: HomePageConfig = {
  theme,
  texts: homeCommonConfig.texts,
}
